import React from 'react';
import Menu from './Menu';
import { MenuItem } from './MenuItem';

interface HelpMenuProps {
  items: MenuItem[];
}

const HelpMenu: React.FC<HelpMenuProps> = ({ items }) => {
  return <Menu items={items} />;
};

export default HelpMenu; 